module.exports = __webpack_public_path__ + "static/media/oxy-logo.0ade4824.svg";